import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import DropDown from "./DropDown";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import InputTextArea from "./InputTextArea";
import { AppDB } from "../App";
import GenericFileCapture from "./GenericFileCapture";
import GenericUploadFileTable from "./GenericUploadFileTable";
import AddCandidateComponet from "../pages/CandidateManagement/Componet/AddCandidateComponet";
import { eventService } from "../services/EventService";
import { applicationsService } from "../services/ApplicationsService";

export default function AddObjections({ show = false, setShow, loadApplications = () => { } }) {
    // var eventGroupService = new EventGroupService();
    var [refresh, setRefresh] = useState(false);
    let [event, setEvent] = useState([]);
    var { toast, lookUp } = useContext(AppDB)
    var [showFileUploader, setShowFileUploader] = useState(false);
    var [fileUploaderDocuments, setFileUploaderDocuments] = useState([])
    var [loading, setLoading] = useState(false);

    useEffect(() => {
        //get event
        eventService
            .getAllEvents({
                PageIndex: 1,
                PageSize: 100000,
                IsPoliticalPaty: true,
                ActiveOnly: true
            })
            .then((res) => {
                setEvent(res);
                setLoading(false);
            });
    }, []);

    // var eventService = new EventService();

    var raw_form = {
        formSerialNumber: "",
        objectionTypeID: "",
        objectionByEntityID: 1,
        objectionAgainstEntityID: 1,
        lodgedByVoterID: "",
        lodgedAgainstVoterID: "",
        eventID: '',
        comment: '',
        applicationChannelID: 4,
        binaryData: [],
        applicationDate: ""
    }
    var [form, setForm] = useState(raw_form);




    function SubmitForm() {
        setLoading(true)
        var clone = { ...form, binaryData: [...fileUploaderDocuments] };
        clone.binaryData = clone.binaryData.map(doc => {
            var d = doc?.binaryData?.split(",");
            if (d?.length >= 2) {
                doc.FileExt = doc.fileExtension
                doc.binaryData = d[1];
                doc.binaryTypeID = doc.documentTypeID

            }
            return doc
        })
        applicationsService.CreateObjection(clone).then(res => {
            if (res?.success) {
                loadApplications();
                setShow(false);
                toast.show({
                    severity: "success",
                    detail: res.message,
                    life: 6000
                });
                setForm(raw_form)
            } else {
                toast.show({
                    severity: "error",
                    detail: res.message,
                    life: 6000
                });
            }
            setLoading(false)

        })
    }

    return (
        <Dialog
            draggable={false}
            header={
                <>
                    <li className="pi pi-plus"> </li>
                    <span>Add Objection</span>
                </>
            }
            footer={
                <>
                    <Button loading={loading} label="Submit" onClick={SubmitForm} className="p-button-success" />
                </>
            }
            visible={show}
            onHide={(e) => setShow(false)}
            style={{ width: "99%", maxWidth: 1000, height: "100%" }}
        >
            <div className="grid">
                <div className="col-12 lg:col-12">
                    <form method="post">
                        <TabView>
                            <TabPanel header="Objection Details">
                                <AddCandidateComponet
                                    ignoreEligibity={true}
                                    isCandidate={false}
                                    info={null}
                                    isNational={null}
                                    error={null}
                                    name="Elector"
                                    required={true}
                                    delimitationID={null}
                                    onUpdate={(voterID, _, village, id_number) => {
                                        if (voterID !== null) {
                                            setForm({ ...form, lodgedAgainstVoterID: voterID })
                                        }
                                    }}
                                    show={true} label="Search Lodged Against ID Number" />

                                <AddCandidateComponet
                                    required={true}
                                    isCandidate={false}
                                    info={null}
                                    isNational={null}
                                    error={null}
                                    name="Elector"
                                    delimitationID={null}
                                    onUpdate={(voterID, _, village, id_number) => {
                                        if (voterID !== null) {
                                            setForm({ ...form, lodgedByVoterID: voterID })
                                        }
                                    }}
                                    show={true} label="Search Lodged By ID Number" />
                                <div className="grid card">


                                    <div className="col-12  lg:col-6">
                                        <TextInput required={true} label="Serial Number" onChange={(e) => setForm({ ...form, formSerialNumber: e.target.value })} options={event} value={form.formSerialNumber} placeholder="" />
                                    </div>

                                    <div className="col-12  lg:col-6">
                                        <DropDown required={true} label="Event" optionLabel="name" optionValue={"eventID"} onChange={(e) => setForm({ ...form, eventID: e.value })} options={event} value={form.eventID} placeholder="Select an Event" />
                                    </div>

                                    <div className="col-12  lg:col-6">
                                        <DropDown required={true} label="Objection Type" optionValue={"id"} optionLabel="name" placeholder="" options={lookUp?.objectionTypes} onChange={(e) => setForm({ ...form, objectionTypeID: e.value })} value={form.objectionTypeID} style={{ width: "100%" }} />
                                    </div>


                                    <div className="col-12  lg:col-6">
                                        <TextInput required={true} type="Calendar" label="Date Lodged" value={form.applicationDate} onChange={(e) => setForm({ ...form, applicationDate: e.target.value })} />
                                    </div>
                                    <div className="col-12  lg:col-12">
                                        <InputTextArea required={true} rows="2" cols="61" label="Comment" value={form.comment} onChange={(e) => setForm({ ...form, comment: e.target.value })} />
                                    </div>
                                    <div className="col-12">
                                        <GenericFileCapture
                                            dontClearDocuments={true}
                                            refresh={refresh} setRefresh={setRefresh}
                                            extraAttributes={{
                                                // "candidateID": selectedCanditate.candidateID,
                                                // "eventID": showCandidateDialog?.event?.eventID
                                            }}
                                            documentTypesLookUp={lookUp?.objectionBinaryTypes} show={showFileUploader} setShow={setShowFileUploader}
                                            setDocuments={setFileUploaderDocuments}
                                            documents={fileUploaderDocuments}
                                        />
                                        <GenericUploadFileTable
                                            header={<div className="col-12  lg:col-3 my-2">
                                                <label htmlFor="description">
                                                    Upload Documents
                                                </label>
                                                <br />
                                                <>
                                                    <Button
                                                        label={"Upload"}
                                                        onClick={(e) => {
                                                            setShowFileUploader(true)
                                                            e.preventDefault()
                                                            e.stopPropagation()
                                                        }}
                                                        className="p-button-success"
                                                        icon={"pi pi-plus"}
                                                    />
                                                </>
                                            </div>}
                                            setDocuments={setFileUploaderDocuments}
                                            documents={fileUploaderDocuments}
                                        />
                                    </div>
                                </div>
                            </TabPanel>
                        </TabView>
                    </form>
                </div>
            </div>
        </Dialog>
    );
}
